import * as React from 'react'
import isEmpty from 'lodash.isempty'
import Help from '../../../../../components/Help'
import ConfigureOptions from '../ConfigureOptions'
import { InputLabel } from '../../../../../components/inputs/InputLabel'
import { templateStyles } from './templateStyles'

export const SELECT_DEFAULT_OPTION_TEXT = 'Select'

export const Form = ({ input, onFormPreviewChange, index }) => {
  const props = input.get('props')

  const options = props.get('preserveOrder')
    ? props.get('options')
    : props.get('options').sort((a, b) => a.get('key').localeCompare(b.get('key')))
  return (
    <div>
      <InputLabel
        title={props.get('label')}
        required={props.get('required') && isEmpty(props.get('value'))}
        requiredLabelStyle={templateStyles.requiredLabel}
        requiredLabelIconName={props.get('requiredLabelIconName')}
      >
        <div className="bp3-select bp3-fill">
          <select
            onChange={e => onFormPreviewChange(index, e.target.value)}
            value={props.get('value')}
            disabled={false}
          >
            <option>{SELECT_DEFAULT_OPTION_TEXT}</option>
            {options.map((opt, i) => {
              return (
                <option key={i} /* eslint-disable-line */ value={opt.get('value')}>
                  {opt.get('value')}
                </option>
              )
            })}
          </select>
        </div>
      </InputLabel>
      {props.get('helpText') && (
        <Help>
          <div>{props.get('helpText')}</div>
        </Help>
      )}
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  return (
    <div>
      <ConfigureOptions input={input} onChange={onChange} />
    </div>
  )
}
